import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
import Avatar from "~/component/Avatar.js";
import adminStyle from "~/admin/lib/style.js";
/** @import { orgMemberResponse } from "~/backend/validate.js"; */

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {Pick<orgMemberResponse, "id" | "org_id" | "name">} member
 */
export default class MemberChip extends Component {
  render() {
    const {
      member
    } = this.props;
    return __h("a", {
      href: "/org/" + member.org_id + "/members/" + member.id,
      "class": adminStyle.chip
    }, __h(Avatar, {
      name: member.name,
      size: 12
    }), __h("span", {}, member.name));
  }
}